export default function findAssociationDefinitions(fromObjectTypeId, toObjectTypeId, associationDefinitionQuery) {
  return associationDefinitionQuery.data.allDefinitions.filter(assoc => assoc.fromObjectTypeId === fromObjectTypeId && assoc.toObjectTypeId === toObjectTypeId);
}